import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoldMedal = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 81,
	viewBox: "0 0 64 81",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_8874_61240)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M21.4102 41.4943L28.1445 45.3823L14.4692 69.0686L10.5441 60.3148L21.4102 41.4943Z",
					fill: "#079E88"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.4102 41.4943L14.6758 37.6062L1.00057 61.2924L10.5441 60.3148L21.4102 41.4943Z",
					fill: "#05668D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.0156 41.4943L24.2813 45.3823L37.9566 69.0686L41.8816 60.3148L31.0156 41.4943Z",
					fill: "#05668D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.0156 41.4943L37.7499 37.6062L51.4252 61.2924L41.8816 60.3148L31.0156 41.4943Z",
					fill: "#079E88"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 26.0053,
					cy: 25.185,
					r: 23.685,
					fill: "url(#paint0_linear_8874_61240)",
					stroke: "#765C00"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 26.0062,
					cy: 25.1848,
					r: 18.098,
					fill: "#A88300"
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask0_8874_61240",
					style: { maskType: "alpha" },
					maskUnits: "userSpaceOnUse",
					x: 8,
					y: 8,
					width: 38,
					height: 38,
					children: /* @__PURE__ */ _jsx("circle", {
						cx: 26.9702,
						cy: 27.1173,
						r: 18.1401,
						fill: "#C28B37"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask0_8874_61240)",
					children: /* @__PURE__ */ _jsx("circle", {
						cx: 26.0034,
						cy: 25.1853,
						r: 18.1401,
						fill: "#C09525"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.1045 12.5649L30.0175 20.3911L37.8437 21.3694L32.4697 27.3955L33.9306 36.0434L26.1045 32.1303L18.2783 36.0434L19.7522 27.3955L14.3652 21.3694L22.1914 20.3911L26.1045 12.5649Z",
					fill: "url(#paint1_linear_8874_61240)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_8874_61240",
				x: .216502,
				y: .216502,
				width: 62.9617,
				height: 80.6046,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 5.48449,
						dy: 5.48449
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.13399 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_8874_61240"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_8874_61240",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_8874_61240",
				x1: 26.0053,
				y1: 2,
				x2: 26.0053,
				y2: 48.3699,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFC600" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FFDE69"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_8874_61240",
				x1: 26.1045,
				y1: 12.5649,
				x2: 26.1045,
				y2: 36.0434,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFFCDD" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FFE896"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgGoldMedal);
export { ForwardRef as ReactComponent };
